module.exports = __webpack_public_path__ + "img/menu.f42d21f3.svg";